import {
  IHubVehicle,
  IHubVehicleCreate,
  IHubVehicleType,
  IHubVehicleBrandModel,
} from 'interfaces/Hub';
import { applyQueryString } from 'lib/queryString';
import { apiHub } from 'services';
import {} from 'interfaces/Hub';
export type VehicleOption = IHubVehicle & {
  value: number;
  name: string;
};

type NameVariant =
  | 'vehicle-type-and-plate'
  | 'vehicle-subtype-and-plate'
  | 'vehicle-subtype-plate-and-axis-count';

type Options = {
  nameVariant: NameVariant;
};

const getName = (
  vehicle: IHubVehicle,
  variant: NameVariant = 'vehicle-type-and-plate'
) => {
  const {
    vehicleType,
    vehicleSubtype,
    vehicle_plate: plate,
    qtd_eixos: axisCount,
  } = vehicle;

  if (variant === 'vehicle-subtype-and-plate') {
    return [vehicleSubtype.name, plate].join(' - ');
  } else if (variant === 'vehicle-type-and-plate') {
    return [vehicleType.name, plate].join(' - ');
  } else if (variant === 'vehicle-subtype-plate-and-axis-count') {
    return [vehicleSubtype.name, `${plate} (${axisCount} eixos)`].join(' - ');
  }
  return '';
};

export function useHubVehicle(options?: Options) {
  const webcol_id = process.env.REACT_APP_HUB_WEBCOL_ID;
  const getListOptionsVehicles = async (
    filters: any
  ): Promise<VehicleOption[]> => {
    const url = applyQueryString(`/vehicle`, {
      ...filters,
      all: true,
      webcol_id,
    });
    const { data } = await apiHub.get<IHubVehicle[]>(url);

    return data.map((vehicle) => ({
      ...vehicle,
      name: getName(vehicle, options?.nameVariant),
      value: vehicle.id,
    }));
  };

  const getVehicle = async (ids: number[]): Promise<IHubVehicle[]> => {
    const url = applyQueryString(`/vehicle`, {
      ids: ids.join(','),
      all: true,
      webcol_id,
    });
    const { data } = await apiHub.get<IHubVehicle[]>(url);

    if (!data.length) {
      return [];
    }
    return data;
  };

  const createVehicle = async (data: Partial<IHubVehicleCreate>): Promise<void> => {
    await apiHub.post('/vehicle', data);
  };

  //   Relacionamentos
  const listVehicleType = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-types`, filter);
    const { data } = await apiHub.get<IHubVehicleType[]>(url);

    const comboOptions = data.map((el: IHubVehicleType) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };
  const listVehicleSubtype = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-subtypes`, filter);
    const { data } = await apiHub.get<IHubVehicleType[]>(url);

    const comboOptions = data.map((el: IHubVehicleType) => ({
      value: el.id,
      name: el.name,
    }));

    return comboOptions;
  };

  const listVehicleBrand = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-brand-model`, filter);
    const { data } = await apiHub.get<IHubVehicleBrandModel[]>(url);

    // Filtra marcas únicas pelo vehicle_brand_id
    const uniqueBrandsMap = new Map<number, IHubVehicleBrandModel>();
    data.forEach((el: IHubVehicleBrandModel) => {
      if (!uniqueBrandsMap.has(el.vehicle_brand_id)) {
        uniqueBrandsMap.set(el.vehicle_brand_id, el);
      }
    });

    const comboOptions = Array.from(uniqueBrandsMap.values()).map(
      (el: IHubVehicleBrandModel) => ({
        value: el.vehicle_brand_id,
        name: el.brand.name,
      })
    );

    return comboOptions;
  };
  const listVehicleModel = async (filter: object): Promise<any> => {
    const url = applyQueryString(`/vehicle-brand-model`, filter);
    const { data } = await apiHub.get<IHubVehicleBrandModel[]>(url);

    const comboOptions = data.map((el: IHubVehicleBrandModel) => ({
      value: el.vehicle_model_id,
      name: el.model.name,
    }));

    return comboOptions;
  };
  return {
    getListOptionsVehicles,
    getVehicle,
    createVehicle,
    listVehicleType,
    listVehicleBrand,
    listVehicleModel,
    listVehicleSubtype,
  };
}
